import { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfigContext } from "../../Context/ConfigContext";
import { useParams } from "react-router-dom";
import { OverlayLoader, Spinner } from "../../Components/Shimmers";
import slugify from "slugify";
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import { Helmet } from "react-helmet";
import UniCarSearch from "../Cars/UniCarSearch";
import PartsHorizontalCard from "../../Components/Cards/PartsHorizontalCard";
import axios from "axios";
import { axiosGet } from "../../Apis/axiosMethods";
import { default_image } from "../../Imgaes";

const CrossFitParts = () => {
  const { gdcURL, currency, apiURL, token, apiB2BURL, business_type } = useContext(ConfigContext);

  const location = useLocation();
  const { t } = useTranslation();

  const locale = localStorage.getItem("lang") ?? "en";
  const [title, setTitle] = useState("Ghayar");

  const dir = localStorage.getItem("dir");
  const { slug } = useParams();

  const parts_slug = slug.split("-");

  const ART_NUMBER = parts_slug[parts_slug.length - 1];
  const PRODUCT_NAME = parts_slug.slice(0, -1).join("-");

  const [loading, setLoading] = useState(true);
  const [isSticky, setSticky] = useState(false);
  const [OEEnable, setOEEnable] = useState(false);

  const [parts, setParts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedBrandTags, setSelectedBrandTags] = useState([]);
  const [ProductGroups, setProductGroups] = useState([]);

  const [limit] = useState(50);
  const [TotalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [selectedBrandsArray, setSelectedBrandsArray] = useState([]);

  const [responsive] = useState({
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 10,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3,
      slidesToSlide: 1,
    },
  });

  const [loadMore, setLoadMore] = useState(false);
  const loadMoreRef = useRef(null);
  const queryParams = new URLSearchParams(location.search);
  const selectedPTID = queryParams.get('group');

  useEffect(() => {
    window.scrollTo(0, 0);
    LoadParts();
  }, [location, selectedBrandTags, page]);

  const LoadParts = async () => {
    try {
      const business_id = localStorage.getItem("business_id");

      setLoading(true);

      const response = await axiosGet(`/Parts/GetMergeCrossFitParts`,
        {
          business_id,
          oe_number: ART_NUMBER,
          lang: locale ?? "en",
          currency: currency ?? "aed",
          limit,
          page,
          pt_id: selectedPTID,
          brands: selectedBrands,
          selectedBrands: selectedBrandsArray?.length
            ? JSON.stringify(selectedBrandsArray)
            : "",
          business_type
        }
      );

      const data = response.data;

      setParts(data.data);

      const hasOENumber = data.data.some(
        (part) => part.ART_TYPE === "OENumber"
      );

      setOEEnable(hasOENumber);
      setTotalPages(data.total_pages);
      setLoadMore(false);
    } catch (error) {
      console.error("Axios error:", error);
    } finally {
      setLoading(false);
    }
  };

  const LoadMoreParts = async () => {
    try {
      const response = await axiosGet(`Parts/GetMergeCrossFitParts`,
        {
          oe_number: ART_NUMBER,
          lang: locale,
          currency: currency,
          limit,
          page: page + 1,
          pt_id: selectedPTID,
          brands: selectedBrands,
          business_type
        }
      );

      const data = response.data;

      setParts((prevParts) => [...prevParts, ...data.data]);
      setPage((prevPage) => prevPage + 1);
    } catch (error) {
      console.error("Axios error:", error);
    }
  };


  const [stockOE, setStockOE] = useState(0);

  const toggleBrand = (SUP_ID, SUP_BRAND, ART_TYPE) => {
    setSelectedBrands((prevSelectedBrands) => {
      if (prevSelectedBrands.includes(SUP_ID)) {
        return prevSelectedBrands.filter((id) => id !== SUP_ID);
      } else {
        return [...prevSelectedBrands, SUP_ID];
      }
    });

    setSelectedBrandsArray((prevArray) => {
      const index = prevArray.findIndex((item) => item.SUP_ID === SUP_ID);
      if (index === -1) {
        var clearBrand = SUP_BRAND;
        const newArray = [...prevArray, { SUP_ID, SUP_BRAND, ART_TYPE }];
        return newArray;
      } else {
        const newArray = prevArray.filter((item) => item.SUP_ID !== SUP_ID);
        return newArray;
      }
    });

    let setSelectedBTs = [...selectedBrandTags];
    const index = selectedBrandTags.findIndex((tag) => tag.SUP_ID === SUP_ID);
    if (index === -1) {
      setSelectedBTs.push({ SUP_ID, SUP_BRAND, ART_TYPE });
    } else {
      setSelectedBTs.splice(index, 1);
    }
    setSelectedBrandTags(setSelectedBTs);
    setPage(0);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    LoadParts();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const { carouselState: { currentSlide } } = rest;
    return (
      <div className="carousel-button-group">
        <button style={{ padding: '2px 6px', position: 'absolute', left: 0, top: '8px', marginLeft: '-40px' }} className={currentSlide === 0 ? 'btn btn-outline-dark btn-sm disable' : 'btn btn-outline-dark btn-sm '} onClick={() => previous()} > <i className="fas fa-chevron-left"></i> </button>
        <button style={{ padding: '2px 6px', position: 'absolute', right: 0, top: '8px', marginRight: '-30px' }} className="btn btn-outline-dark btn-sm" onClick={() => next()} ><i className="fas fa-chevron-right"></i></button>
      </div>
    );
  };

  const BrandsTags = () => {
    return parts && parts.length > 0 && selectedBrandTags && (
      <div>
        <h6 style={{ lineHeight: 0, marginTop: "10px" }}>
          {selectedBrandTags.length !== 0 && t("selected_filters")}
        </h6>
        {selectedBrandTags && selectedBrandTags.map((item, index) => {
          return (
            <span
              onClick={() =>
                toggleBrand(item.SUP_ID, item.SUP_BRAND)
              }
              className="badge badge-pill  mr-4 pt-2 pb-2"
              style={{ backgroundColor: "#e9e9e9" }}
              key={`tags-${item.SUP_ID}`}>
              {item.SUP_BRAND}{" "}
              <i className="fas fa-times-circle lightColorText"></i>{" "}
            </span>
          );
        })}
      </div>
    );
  };

  const GetBrandList = () => {
    return parts &&
      [...parts]
        .filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.ART_SUP_BRAND === value.ART_SUP_BRAND
          ))
        )
        .map((img, index) => {
          // add comma
          return img.ART_SUP_BRAND.trim() + (index < parts.length - 1 ? ', ' : '');
        })
  }

  const GetPriceRange = () => {
    const prices = parts
      .map(p => p.VD_BB_PRICE)
      .filter(price => price != null && !isNaN(price));

    if (prices.length === 0) return "No prices available";

    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);

    return `${minPrice.toFixed(2)} - ${maxPrice.toFixed(2)} AED`;
  }

  const GetOEMNumbers = () => {
    var allOEMS = [];

    for (var i = 0; i < parts.length; i++) {
      const oemData = parts[i].OE_NUMBERS_CROSS;

      if (oemData !== 'null' && oemData !== null && oemData !== undefined) {
        try {
          // Parse the JSON string to an array
          const parsedOEM = JSON.parse(oemData);

          // Check if it's an array before iterating
          if (Array.isArray(parsedOEM)) {
            for (var j = 0; j < parsedOEM.length; j++) {
              if (parsedOEM[j]?.ARL_SEARCH_NUMBER) {
                allOEMS.push(parsedOEM[j].ARL_SEARCH_NUMBER);
              }
            }
          }
        } catch (error) {
          console.error("Failed to parse OEM data:", error);
        }
      }
    }

    // Remove duplicates
    var uniqueOEMs = [...new Set(allOEMS)];

    // Join with commas (simplified)
    return uniqueOEMs;
  }


  const GetCarMakers = () => {
    var allOEMS = [];

    for (var i = 0; i < parts.length; i++) {
      const oemData = parts[i].OE_CROSS_NUMBERS;

      if (oemData !== "null" && oemData !== null && oemData !== undefined) {
        try {
          // Parse the JSON string to an array
          const parsedOEM = JSON.parse(oemData);

          // Check if it's an array
          if (Array.isArray(parsedOEM)) {
            for (var j = 0; j < parsedOEM.length; j++) {
              const brand = parsedOEM[j]?.ARL_BRA_BRAND;

              if (brand && typeof brand === "string" && brand.trim() !== "") {
                allOEMS.push(brand.trim());
              }
            }
          }
        } catch (error) {
          console.error("Failed to parse OE_CROSS_NUMBERS:", error);
        }
      }
    }

    const uniqueOEMs = [...new Set(allOEMS)];

    // Return as comma-separated string
    return uniqueOEMs.join(", ");
  };

  const BrandsOptions = () => {
    const stockOEBrand = stockOE === 1 ? {
      SUP_ID: 0,
      SUP_BRAND: 'Stock OE',
      SUP_FULL_NAME: 'Stock OE Parts',
      SUP_LOGO_NAME: 'oem_icon.png',
      isSpecial: true
    } : null;

    const allBrands = stockOE === 1
      ? [stockOEBrand, ...(brands || [])]
      : brands || [];

    var divs = <div style={{ position: 'relative' }} className={`prevent-select ${selectedBrandTags && selectedBrandTags.length !== 0 && 'mt-2'}`}>
      <Carousel
        arrows={false}
        renderButtonGroupOutside={allBrands.length > 10}
        customButtonGroup={<ButtonGroup />}
        responsive={responsive}
        swipeable={true}
        draggable={true}
        showDots={false}
        infinite={false}
        autoPlaySpeed={1000}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={500}
        containerClass="carousel-container"
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px">

        {allBrands &&
          [...allBrands]
            .sort((a, b) => {
              if (a.SUP_ID === 0) return -1;
              if (b.SUP_ID === 0) return 1;
              return selectedBrands.includes(b.SUP_ID) - selectedBrands.includes(a.SUP_ID);
            })
            .map((img, index) => {
              const handleBrandClick = () => {
                if (img.SUP_ID === 0) {
                  toggleBrand(
                    0,
                    'OEM',
                    'OENumber'
                  );
                  window.scrollTo(0, 0);
                  setPage(1)
                } else {
                  toggleBrand(
                    img.SUP_ID,
                    img.SUP_BRAND.trim().replace(/[\r\n]/g, '').replace(/&/g, '__AMP__'),
                    'IAM'
                  );
                  window.scrollTo(0, 0);
                  setPage(1)
                }
              };

              return (
                <div
                  key={`img-sup-brand-${img.SUP_ID}-${index}`}
                  onClick={handleBrandClick}
                  style={{
                    cursor: 'pointer',
                    height: '40px',
                    width: '80px',
                    textAlign: 'center',
                    border: selectedBrands.includes(img.SUP_ID)
                      ? '2px solid #cc000b'
                      : '0px solid #CCC',

                    ...(img.SUP_ID === 0 ? {
                      backgroundColor: '#f0f8ff',
                      borderRadius: '5px',
                      border: '1px dashed #007bff'
                    } : {})
                  }}
                  title={img.SUP_FULL_NAME}
                >
                  <ImageWithFallback
                    src={img.SUP_ID === 0
                      ? '/assets/images/brands/OEM.png'
                      : `${gdcURL}/sup-logo/${img.SUP_LOGO_NAME}`
                    }
                    alt={img.SUP_BRAND}
                    index={index}
                    fallbackText={img.SUP_BRAND}
                    OE={false}
                  />
                </div>
              );
            })}
      </Carousel>
    </div>
    return divs;
  };

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 200) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    try {
      setTitle(PRODUCT_NAME.replaceAll('-', ' ').replaceAll('_', ' ').replaceAll('  ', ' ').replaceAll('  ', ' ').trim());
    } catch (err) {
      setTitle('Ghayar');
    }
  }, [location]);

  const getFilteredTitle = () => {
    var sTitle = title.split(" ");
    sTitle = sTitle.slice(0, sTitle.length - 4);
    return sTitle.join(" ");
  }

  return (
    loading ? (
      <div style={{ height: "100vh" }}>
        <OverlayLoader />
      </div>
    ) :
      <div
        className="header-bottom"
        style={{
          borderBottom: "1px solid rgb(226, 226, 226)",
          marginBottom: "10px",
        }}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <div className="container">
          <nav
            className="main-nav w-100"
            style={{ textAlign: dir === "rtl" ? "right" : "left" }}>
            <div className="row justify-content-center">
              <div className="col-md-3">
                <UniCarSearch redirectURL={`/Spare-Parts/OEM/${PRODUCT_NAME}-${ART_NUMBER}`} />
              </div>

              <div className="col-md-9">
                <h2 className="mt-2" style={{ color: '#132530', fontFamily: 'Montserrat, Arial, sans-serif', fontSize: '22px', fontWeight: '500', lineHeight: '24px' }}>
                  {getFilteredTitle()} {ART_NUMBER}
                </h2>

                <table className="table table-bordered" style={{ fontSize: '12px', color: '#132530', fontFamily: 'Montserrat, Arial, sans-serif', lineHeight: '1.5' }}>
                  <tbody>
                    <tr>
                      <td>
                        An OEM number is a unique code containing letters and digits. Car manufacturers use them to mark every part inside their cars. A non-original car part carrying an OEM number demonstrates that the part meets stringent car manufacturer standards and its parameters and technical specifications are identical to original equipment.
                      </td>
                    </tr>

                    <tr >
                      <td className="card-body">
                        All spare parts in the list below are equivalent to OEM number: <strong>{ART_NUMBER}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <h5 className="mt-4" style={{ color: '#132530', fontFamily: 'Montserrat, Arial, sans-serif', lineHeight: '0px' }}>
                  {getFilteredTitle()} OEM {ART_NUMBER}: Cost and Alternatives
                </h5>



                {
                  parts?.length > 0 ?
                    <div className="col-md-12">
                      <table className="table table-bordered" style={{ fontSize: '12px', color: '#132530', fontFamily: 'Montserrat, Arial, sans-serif', lineHeight: '1.5' }}>
                        <tr> <td>Price</td> <td>{parts && GetPriceRange()}</td> </tr>
                        <tr> <td>OEM Brand</td> <td>{parts && GetBrandList()}</td> </tr>
                        <tr> <td>Car Make</td> <td>{parts && GetCarMakers()}</td> </tr>
                        {/* <tr> <td>OEM {ART_NUMBER} Equivalents</td> <td>{parts && GetOEMNumbers()}</td> </tr> */}
                        {/* <tr>
                          <td style={{
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            maxWidth: '100px'  // Adjust as needed
                          }}>
                            OEM {ART_NUMBER} Equivalents
                          </td>
                          <td style={{
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            wordBreak: 'break-all',  // This will break long strings
                            maxWidth: '300px'  // Adjust as needed
                          }}>
                            {parts && GetOEMNumbers()}
                          </td>
                        </tr> */}
                      </table>

                      <div style={isSticky ? {
                        position: 'fixed',
                        top: '0',
                        backgroundColor: '#FFF',
                        width: '100%',
                        left: '0',
                        zIndex: '1000',
                        padding: '10px 50px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        zIndex: 10000000
                      } : {}}>
                        {isSticky &&
                          <div className="row">
                            <div className="col-4" style={{
                              color: '#59666e',
                              fontFamily: 'Montserrat, Arial, sans-serif',
                              fontSize: '12px',
                              fontWeight: '500',
                              lineHeight: '2',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                              paddingRight: '3%'
                            }}>
                              {/* {t('best_department_for', {car,'department': (STR_NODE_NAME.replaceAll('-', ' ').replaceAll('_', ' ').replaceAll('  ', ' ').replaceAll('  ', ' ').trim())})} */}
                            </div>
                            <div className="col-8">
                              {Array.isArray(brands) && brands.length > 0 && <BrandsOptions />}
                            </div>
                          </div>
                        }
                        {!isSticky &&
                          <div className={dir === 'rtl' ? "pr-5" : 'pl-5'}>
                            {Array.isArray(brands) && brands.length > 0 && <BrandsTags />}
                            {Array.isArray(brands) && brands.length > 0 && <BrandsOptions />}
                          </div>
                        }
                      </div>

                      <div className="row">
                        <div className="container pt-5">
                          {Array.isArray(parts) && parts.length > 0 && t('total_items', { total: parts.length })}
                        </div>
                        <div className="row pb-4">

                          {parts && parts.length > 0 && parts.map((part, index) => {

                            const OE_part_slug = slugify(`${part.ART_PRODUCT_NAME}`.toLowerCase()) +
                              "-" +
                              slugify(`${part.ART_SEARCH_NUMBER}`.toLowerCase())
                              +
                              `/${part?.stock_brand_name}`
                              ;

                            const part_slug =
                              slugify(
                                part?.ART_PRODUCT_NAME
                                  ?.toString()
                                  .trim()
                                  .replace(/,/g, "")
                                  .replace(/\s+/g, "-")
                                  .toLowerCase()
                              ) +
                              "-" +
                              slugify(part?.ART_SEARCH_NUMBER?.toString().toLowerCase()) +
                              "-" +
                              slugify(part?.ART_SUP_ID?.toString().toLowerCase());

                            const partImg = part.MEDIA_SOURCE ? part.MEDIA_SOURCE : default_image

                            return (
                              <PartsHorizontalCard
                                key={`r-part - id - ${part.ART_ID} -${index} `}
                                partImg={partImg}
                                criteria={part?.ARTICLE_CRITERIA_JSON}
                                url={part.ART_TYPE === 'OENumber' ? `/OE-Spare-Parts/Details/${OE_part_slug}` : `/Spare-Parts/Details/${part_slug}`}
                                id={part.ART_ID}

                                title={part.ART_PRODUCT_NAME}
                                number={part.ART_ARTICLE_NR}

                                price={business_type === 1 ? part?.VD_BG_PRICE : part.VD_BB_PRICE ?? 0}

                                display_price={part?.display_price}

                                mrp={part.VD_PRICE_MRP ?? 0}
                                display_price_mrp={`AED ${part.VD_PRICE_MRP ? part.VD_PRICE_MRP.toFixed(2) : 0} `}
                                qty={part.VD_QTY}
                                imgUrl={partImg}
                                action={true}
                                brand={part.stock_brand_name}
                                suplogo={part.SUP_LOGO_NAME}
                                supid={part.SUP_ID}
                                redLabel={3 === 3 ? `Aftermarket` : "Genuine"}
                                partInfo={part.ART_INFO}
                                pt_intl={part.PT_INTL}
                                art_type={part.ART_TYPE}
                                mfa_id={part.E_MFA_ID}
                                part={part}

                                SUP_WARRANTY={part?.SUP_WARRANTY}
                                stock_delivery_days={part?.stock_delivery_days}

                              />
                            );
                          })}
                        </div>
                      </div>

                      <div className="col-lg-12">
                        {TotalPages > 1 && <div className="text-center mb-2">
                          <button
                            className="btn btn-dark pl-5 pr-5 pt-3 pb-3"
                            style={{ fontSize: '12px' }}
                            onClick={() => {
                              LoadMoreParts();
                            }}
                          >
                            <i className="fas fa-redo mr-2"></i> {t('load_more')}
                          </button>
                        </div>}
                        {TotalPages > 1 && (
                          <div className="pagination-container">
                            <nav aria-label="Page navigation">
                              <ul style={{ color: '#0d1f2a' }} className="pagination justify-content-center">
                                <li className={`page - item ${page === 0 && 'disabled'} `}>
                                  <button
                                    className="page-link"
                                    onClick={() => handlePageChange(page - 1)}
                                    disabled={page === 0}
                                  >
                                    <i style={{ fontSize: '12px' }} className="fas fa-arrow-left"></i>
                                  </button>
                                </li>
                                {Array.from({ length: TotalPages }, (_, i) => (
                                  <li
                                    key={i}
                                    className={`page - item ${page === i && 'active'} `}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => handlePageChange(i)}
                                    >
                                      {i + 1}
                                    </button>
                                  </li>
                                ))}
                                <li className={`page - item ${page === TotalPages - 1 && 'disabled'} `}>
                                  <button
                                    className="page-link"
                                    onClick={() => handlePageChange(page + 1)}
                                    disabled={page === TotalPages - 1}
                                  >
                                    <i style={{ fontSize: '12px' }} className="fas fa-arrow-right color-dark"></i>
                                  </button>
                                </li>
                              </ul>
                            </nav>
                          </div>
                        )}
                      </div>

                      <div ref={loadMoreRef} style={{ visibility: 'hidden' }}>LoadMOre {TotalPages} === {page}</div>

                      <div className="row justify-content-center">
                        <div className="col-sm-2 pb-5">
                          {loadMore === true && (
                            <div className="mt-5">
                              <center>
                                <Spinner />
                              </center>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    :
                    <>
                      <div className="card out-of-stock-card">
                        <div className="out-of-stock-icon">
                          <i className="fas fa-exclamation-circle"></i>
                        </div>

                        <div className="out-of-stock-title">
                          Temporarily Out of Stock
                        </div>

                        <div className="out-of-stock-text">
                          This part is currently unavailable and will be restocked soon.
                          Our team is updating inventory to make it available shortly.
                          <br /><br />
                          Thank you for your patience. Please check back again soon for updates.
                        </div>
                      </div>

                      <style>
                        {`
                          .out-of-stock-card {
                          border: 1px solid #e0e0e0;
                          border-left: 6px solid #ff4b4b; 
                          border-radius: 12px;
                          padding: 35px 30px;
                          background: #ffffff;
                          box-shadow: 0px 4px 14px rgba(0,0,0,0.07);
                          text-align: center;
                          max-width: 650px;
                          margin: 50px auto;
                          font-family: 'Montserrat', Arial, sans-serif;
                        }  

                          .out-of-stock-icon {
                          font-size: 50px;
                          color: #ff4b4b;
                          margin-bottom: 15px;
                        } 

                          .out-of-stock-title {
                          font-size: 22px;
                          font-weight: 600;
                          color: #0d1f2a;
                          margin-bottom: 12px;
                        }

                          .out-of-stock-text {
                          font-size: 15px;
                          color: #4a5a67;
                          line-height: 1.7;
                          max-width: 500px;
                          margin: 0 auto;
                        }
                      `}
                      </style>
                    </>

                }





                <br />
                <br />
              </div>
            </div>
          </nav>
        </div>
      </div>
  );
};

const ImageWithFallback = ({ src, index, alt, fallbackText, OE }) => {
  const [imgError, setImgError] = useState(false);

  const handleError = () => {
    setImgError(true);
  };
  const fallbackStyle = {
    textAlign: "center",
    fontSize: "10px",
    padding: "10px",
    wordBreak: "break-word",
    maxWidth: "90%",
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

  };
  return (
    <div style={containerStyle}>
      {imgError ? (
        <div style={fallbackStyle}>{fallbackText}</div>
      ) : (
        <img
          draggable="false"
          style={{
            height: "30px",
            margin: "auto",
            float: "none",
            marginTop: OE === false ? "5px" : 0,
          }}
          key={`img-part-${index}`}
          src={src}
          alt={alt}
          onError={handleError}
        />
      )}
    </div>
  );
};

export default CrossFitParts;




// import { useEffect, useState } from 'react';
// import { Helmet } from 'react-helmet';
// import { useParams } from 'react-router-dom';
// import AFMParts from './PartsTabs/CrossParts/AFMParts';
// import UniCarSearch from '../Cars/UniCarSearch';
// import OEMParts from './PartsTabs/CrossParts/OEMParts';
// import TabMenu from './PartsTabs/TabMenu';

// const CrossFitParts = () => {

//   const [title, setTitle] = useState("Ghayar");
//   const { ART_ID, ART_NUMBER, STR_NODE_NAME } = useParams();
//   const [activeTab, setActiveTab] = useState("AFM");

//   useEffect(() => {
//     try {
//       if (STR_NODE_NAME) {
//         setTitle(
//           STR_NODE_NAME
//             .replaceAll('-', ' ')
//             .replaceAll('_', ' ')
//             .replace(/\s+/g, ' ')
//             .trim()
//         );
//       }
//     } catch {
//       setTitle("Ghayar");
//     }
//   }, [STR_NODE_NAME]);

//   return (
//     <div
//       className="header-bottom d-none d-lg-block"
//       style={{
//         borderBottom: "1px solid rgb(226, 226, 226)",
//         marginBottom: "10px",
//       }}
//     >
//       <Helmet>
//         <title>{title}</title>
//       </Helmet>

//       <div className="container">
//         <nav className="main-nav w-100">
//           <div className="row justify-content-center">
//             <div className="col-md-3">

//               <UniCarSearch redirectURL={`/Spare-Parts/OEM/${ART_ID}/${STR_NODE_NAME}`} />
//             </div>

//             <div className="col-md-9 mt-2">
//               <TabMenu activeTab={activeTab} setActiveTab={setActiveTab} />


//               <div className="tab-content">
//                 {activeTab === "AFM" && <AFMParts
//                   ART_NUMBER={ART_NUMBER}
//                   activeTab={activeTab}
//                 />}

//                 {activeTab === "OEM" && <OEMParts
//                   ART_NUMBER={ART_NUMBER}
//                   activeTab={activeTab}
//                 />}

//               </div>

//             </div>

//           </div>



//         </nav>
//       </div>
//     </div>
//   );
// };

// export default CrossFitParts;
